module.exports = __webpack_public_path__ + "static/media/video1.090d941c.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/video/video1.mp4
// module id = 33
// module chunks = 0